export const initialState = {
  profile: {
    id: '4ad3fe1b-d179-417d-9927-4b38bbf23e76',
    name: 'Jana Khanji',
    email: 'jana.khanji@ieee.org',
    Avatar: '',
    language: 'ar',
    gender: 'female',
    birthday: {
      month: 11,
      day: 18,
      year: 1998,
    },
    theme_id: 1,
  },
  events: [
    {
      id: 1,
      title: "Mom's Birthday",
      description: '',
      type_id: 2,
      date: 'Thu Feb 25 2021',
    },
    {
      id: 2,
      title: 'string',
      description: 'string',
      type_id: 1,
      date: 'Sun Feb 28 2021',
    },
    {
      id: 3,
      title: 'string',
      description: 'string',
      type_id: 1,
      date: 'Tue Mar 02 2021',
    },
    {
      id: 5,
      title: 'testing',
      description: 'string',
      type_id: 1,
      date: 'Wed Sep 01 2021',
    },
    {
      id: 6,
      title: 'testing',
      description: 'string',
      type_id: 2,
      date: 'Thu Sep 02 2021',
    },
    {
      id: 7,
      title: 'testing',
      description: 'string',
      type_id: 2,
      date: 'Thu Sep 02 2021',
    },
  ],
  trackers: [
    {
      id: 1,
      title: 'brush my teeth',
      duration: 14,
      StartDate: 'Sat Feb 20 2021',
      completed: true,
      track: [
        { id: 1, status: 'checked', date: 'Sat Feb 20 2021' },
        { id: 2, status: 'unchecked', date: 'Sun Feb 21 2021' },
        { id: 3, status: 'checked', date: 'Mon Feb 22 2021' },
        { id: 4, status: 'checked', date: 'Tue Feb 23 2021' },
        { id: 5, status: 'checked', date: 'Wed Feb 24 2021' },
        { id: 6, status: 'checked', date: 'Thu Feb 25 2021' },
        { id: 7, status: 'checked', date: 'Fri Feb 26 2021' },
        { id: 8, status: 'checked', date: 'Sat Feb 27 2021' },
        { id: 9, status: 'unchecked', date: 'Sun Feb 28 2021' },
        { id: 10, status: 'checked', date: 'Mon Mar 01 2021' },
        { id: 11, status: 'checked', date: 'Tue Feb 02 2021' },
        { id: 12, status: 'checked', date: 'Wed Feb 03 2021' },
        { id: 13, status: 'checked', date: 'Thu Feb 04 2021' },
        { id: 14, status: 'checked', date: 'Fri Feb 05 2021' },
      ],
    },
  ],
  collections: [
    {
      date: 'Sun Feb 28 2021',
      id: 1,
      type: { id: 5 },
      text: 'today was a great day, we had so mush fun, yeaaaa',
      starred: true,
    },
    {
      date: 'Sun Feb 28 2021',
      id: 2,
      type: { id: 5 },
      text: 'I just waant to die XD',
      starred: false,
    },
    {
      date: 'Sun Feb 28 2021',
      id: 3,
      type: { id: 2 },
      text: 'I just waant to die XD',
      starred: true,
    },
    {
      date: 'Fri Feb 26 2021',
      id: 4,
      type: { id: 5 },
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      starred: false,
    },
    {
      date: 'Fri Mar 12 2021',
      id: 5,
      type: { id: 1 },
      text: 'Love alarm 2',
      starred: false,
    },
    {
      date: 'Thu Mar 04 2021',
      id: 6,
      type: { id: 1 },
      text: 'hello from the other side',
      starred: false,
    },
    {
      date: 'Sun Feb 28 2021',
      id: 7,
      type: { id: 2 },
      text: 'I just waant to die XD',
      starred: false,
    },
    {
      date: 'Sun Feb 28 2021',
      id: 8,
      type: { id: 4 },
      text: 'i missed u today',
      starred: false,
    },
    {
      date: 'Thu Feb 25 2021',
      id: 9,
      type: { id: 3 },
      text: 'hey im here',
      starred: true,
    },
  ],
  interest: [
    {
      id: 1,
      title: 'Anime',
      deadline: '2021-03-18',
      goal: 10,
      completedItems: 3,
      completed: false,
      items: [
        { id: 1, title: 'Attack on titan', completed: true },
        { id: 2, title: 'jujutsu kaisen', completed: true },
        { id: 3, title: 'Horimiya', completed: true },
        { id: 4, title: 'beastars', completed: false },
      ],
    },
  ],
};
